import React from 'react';
import './GlassCard.scss';

export const GlassCard = ({
  children,
  variant = 'default',
  className = '',
  onClick,
  ...props
}) => {
  const getCardClass = () => {
    switch (variant) {
      case 'compact':
        return 'card-glass-compact';
      case 'large':
        return 'card-glass-large';
      default:
        return 'card-glass';
    }
  };

  const cardClass = `${getCardClass()} ${className}`.trim();

  return (
    <div
      className={cardClass}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      {...props}
    >
      {children}
    </div>
  );
};
